import React from 'react';
import BaseText from '../../ui/typography/BaseText';
import InternalLinkButton from '../../ui/buttons/InternalLinkButton';
import ExternalLinkButton from '../../ui/buttons/ExternalLinkButton';
import { FONT_SIZE } from '../../../constants/enum';
import H2HeaderText from '../../ui/typography/H2HeaderText';
import IconCheckCircle from '../../../images/inline/check-circle.inline.svg';
import { StaticImage } from 'gatsby-plugin-image';
import Home from '../../../images/inline/home.inline.svg';
import Cloud from '../../../images/inline/cloudIcon.inline.svg';
import Digital from '../../../images/inline/digitalIcon.inline.svg';
import { LINKS } from '../../../constants/enum';
import ContactModal from '../../common/ContactModal';
export default function WhyAirCorporate() {
  return (
    <div className="bg-blue-100 pt-60">
      <div className="global-max-width-wrapper mx-auto">
        <h3 className="text-45ct text-center mt-2">Why Air Corporate</h3>
        <BaseText
          className="md:whitespace-pre-line mt-4"
          textAlign="text-center"
          fontWeight="text-medium"
          textColor="text-gray-300"
          title={`Air Corporate is more than just shuttling your new Hong Kong company through \nthe company registration process. We make the formation and management of \nyour new Hong Kong company, including corporate shareholders, transparent, \neasy, and nearly automatic.\n\nWe use the right balance between technology and human experience:`}
        />
        <div className="flex flex-col md:flex-row md:mx-40 items-center justify-between mt-8">
          <div className="flex flex-col items-center">
            <div
              style={{ minWidth: '90px', minHeight: '90px', maxWidth: '90px', maxHeight: '90px' }}
              className="bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center"
            >
              <Home />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-4"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Remote Hong Kong \n company registration`}
            />
          </div>
          <div className="flex flex-col items-center md:mx-8 mt-4 md:mt-0">
            <div
              style={{ minWidth: '90px', minHeight: '90px', maxWidth: '90px', maxHeight: '90px' }}
              className="bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center"
            >
              <Cloud />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-4"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Online accounting`}
            />
          </div>
          <div className="flex flex-col items-center md:ml-8 mt-4 md:mt-0">
            <div
              style={{ minWidth: '90px', minHeight: '90px', maxWidth: '90px', maxHeight: '90px' }}
              className="bg-white relative z-10 text-32ct text-bold text-orange-500 rounded-full flex items-center justify-center"
            >
              <Digital />
            </div>
            <BaseText
              className="md:whitespace-pre-line mt-4"
              textAlign="text-center"
              fontWeight="text-medium"
              textColor="text-gray-300"
              title={`Digital bank account\n opening`}
            />
          </div>
        </div>

        {/* <div className="flex w-full justify-center mt-12 pb-44">
          <InternalLinkButton
            caption="Get Started"
            fontSize={FONT_SIZE.PX_16}
            padding="16px 24px"
            href="#plan-section"
          />
        </div> */}

        <div className="flex w-full justify-center mt-12 pb-44">
          <a
            href="#plan-section"
            className="bg-orange-500 text-white px-6 py-3 rounded-md text-medium hover:bg-gray-700 hover:text-white"
          >
            Get Started
          </a>
        </div>

        <div className="flex flex-col md:flex-row justify-between gap-16">
          <div className="flex flex-col gap-10">
            <H2HeaderText
              fontWeight="text-regular"
              className="md:whitespace-pre-line"
              title={`Get the right business \naccount for your \ncompany`}
            />
            <BaseText
              textColor="text-gray-300"
              fontWeight="text-medium"
              title={`Save time getting the right guidance.`}
            />
            <div className="flex gap-2">
              <IconCheckCircle stroke="#06f" />
              <BaseText textColor="text-gray-300" fontWeight="text-medium" title={`Traditional or online banks`} />
            </div>
            <div className="flex gap-2">
              <IconCheckCircle stroke="#06f" />
              <BaseText textColor="text-gray-300" fontWeight="text-medium" title={`Multiple currency acccounts`} />
            </div>
            <div className="flex gap-2">
              <IconCheckCircle stroke="#06f" />
              <BaseText textColor="text-gray-300" fontWeight="text-medium" title={`Pay and get paid internationally`} />
            </div>
            <ContactModal>
              <InternalLinkButton
                path="?=contact"
                className="mt-5"
                fontSize={FONT_SIZE?.PX_15}
                padding="16px 20px"
                caption="Contact Us"
              />
            </ContactModal>
          </div>
          <StaticImage
            className="w-full md:w-auto"
            src="../../../images/homePageImages/homeCard.png"
            objectFit="contain"
            alt="visa"
            loading="lazy"
          />
        </div>
        <div className="flex flex-col items-center md:flex-row  mt-20 md:justify-between justify-center gap-20">
          <div className="flex flex-col text-center md:text-left w-8/12 flex-col gap-10">
            <H2HeaderText
              fontWeight="text-regular"
              className="md:whitespace-pre-line pt-20"
              title={`Learn with us on YouTube`}
            />
            <BaseText
              textColor="text-gray-300"
              fontWeight="text-medium"
              className="md:whitespace-pre-line"
              title={`Our team has helped thousands of entrepreneurs, businesses and SMEs navigate the world of business in Asia with our YouTube Channel videos and tutorials.\n\nWe help you save money while keeping you safe incorporating and managing your company`}
            />
            <ExternalLinkButton
              className="mt-5"
              fontSize={FONT_SIZE?.PX_15}
              padding="16px 20px"
              bgColor="bg-red-600"
              caption="Subscribe to our Channel"
              href={`${LINKS?.youtube_subscribe}`}
              target="_blank"
              rel="noopener noreferrer"
            />

            <StaticImage
              className="w-full -mr-24 flex flex-col items-center"
              src="../../../images/homePageImages/young-woman-left.png"
              objectFit="contain"
              alt="woman"
              loading="lazy"
              style={{ WebkitTransform: 'scaleX(-1)' }}
            />
          </div>
          <StaticImage
            className="w-full -mr-24 rounded-lg flex flex-col items-center youtube-image"
            src="../../../images/homePageImages/air-corporate-youtube.png"
            objectFit="contain"
            imgStyle={{ borderRadius: '8px' }}
            alt="youtube"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}
